import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; // Import FormsModule here

import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';

import { Comment } from '../../models/comments';
import { FilterByUserTypePipe } from '../../shared/pipes/FilterByUserTypePipe';
@Component({
  selector: 'app-comments-container',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, MatTabsModule, MatButtonModule, FilterByUserTypePipe],
  templateUrl: './comments-container.component.html',
  styleUrl: './comments-container.component.scss'
})
export class CommentsContainerComponent {
  // comments = [
  //   { user: 'Deepak', timestamp: new Date('2024-01-01T12:34:00'), text: 'Hey Semin, can you check the issue with second assignment!' },
  //   { user: 'Semin', timestamp: new Date('2024-01-02T13:24:00'), text: 'Yeah Sure!' }
  // ];
  // @Input commentsColor: string = 'primary';
  comments: Comment[] = [];
  newCommentText = 'Hey there!!';
  userTypes = ['CW Internal - Public', 'CW Internal - Private', 'External / Client'];
  postComment() {
    // if (this.newCommentText.trim()) {
    //   this.comments.push({
    //     user: 'Current User',
    //     text: this.newCommentText,
    //     timestamp: new Date()
    //   });
    //   this.newCommentText = '';  // Clear the input field
    // }
    const newComment: Comment = {
      id: this.comments.length + 1,
      text: this.newCommentText,
      user: 'current user', // replace with actual user retrieval logic
      userType: 'Internal', // replace as above
      timestamp: new Date(),
      replies: [],
      attachments: []
    };
    this.comments.push(newComment);
    this.newCommentText = '';
  }

  replyToComment(commentId: number) {
    // Implement reply logic
  }

  onFileSelected(event: any, commentId: number) {
    // Implement file upload logic
  }
}
